import React, { useState, useEffect } from 'react';
import { fetchOptions } from '../apiService';
import Select from 'react-select';
import '../App.css';

const CoverageCheckModal = ({ onClose }) => {
  const [complexes, setComplexes] = useState([]);
  const [suburbs, setSuburbs] = useState([]);
  const [selectedComplex, setSelectedComplex] = useState(null);
  const [selectedSuburb, setSelectedSuburb] = useState(null);
  const [checkResult, setCheckResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isCovered, setIsCovered] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const suburbsData = await fetchOptions('suburb');
        setSuburbs(suburbsData);

        const complexesData = await fetchOptions('complex');
        setComplexes(complexesData);
      } catch (error) {
        console.error('Error fetching coverage data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleCheckCoverage = () => {
    setCheckResult(null);

    if (!selectedComplex || !selectedSuburb) {
      setCheckResult({
        covered: false,
        message: 'Please select both a complex/building and suburb.',
      });
      return;
    }

    // Check if the complex exists in the selected suburb
    const complexExists = complexes.some(
      (complex) =>
        complex.name === selectedComplex.value
    );

    // Check if suburb exists in the list
    const suburbExists = suburbs.some(
      (suburb) => suburb.name === selectedSuburb.value
    );

    if (complexExists && suburbExists) {
      setIsCovered(true);
      setCheckResult({
        covered: true,
        message: `Great! ${selectedComplex.value} in ${selectedSuburb.value} is covered. You can now apply for our fibre service.`,
      });
    } else {
      setIsCovered(false);
      setCheckResult({
        covered: false,
        message: `Unfortunately, ${selectedComplex.value} in ${selectedSuburb.value} is not currently covered. Please check back later or contact us for more information.`,
      });
    }
  };

  return (
    <div className="modal show" style={{ display: 'block' }} tabIndex={-1} role="dialog">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header text-white" style={{ backgroundColor: '#e2520f' }}>
            <h5 className="modal-title">Check Coverage</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            {loading ? (
              <p>Loading coverage data...</p>
            ) : (
              <>
                <div className="mb-3">
                  <label htmlFor="complex" className="form-label">
                    Complex / Building / Business
                  </label>
                  <Select
                    inputId="complex"
                    options={complexes.map((complex) => ({
                      value: complex.name,
                      label: complex.name,
                    }))}
                    onChange={setSelectedComplex}
                    placeholder="Search or select a complex"
                    isSearchable
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        borderColor: state.isFocused ? '#e56521' : base.borderColor,
                        boxShadow: state.isFocused ? '0 0 0 1px #e56521' : base.boxShadow,
                        '&:hover': {
                          borderColor: '#e56521',
                        },
                      }),
                    }}
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="suburb" className="form-label">
                    Suburb
                  </label>
                  <select
                    id="suburb"
                    className="form-control"
                    onChange={(e) =>
                      setSelectedSuburb({
                        value: e.target.value,
                        label: e.target.value,
                      })
                    }
                    value={selectedSuburb?.value || ''}
                  >
                    <option value="">Select a suburb</option>
                    {suburbs.map((suburb) => (
                      <option key={suburb.id} value={suburb.name}>
                        {suburb.name}
                      </option>
                    ))}
                  </select>
                </div>

                {checkResult && (
                  <div
                    className={`alert ${
                      isCovered ? 'alert-success' : 'alert-danger'
                    }`}
                  >
                    <strong>{isCovered ? 'Covered!' : 'Not Covered'}</strong>
                    <br />
                    {checkResult.message}
                  </div>
                )}
              </>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleCheckCoverage}
              style={{ backgroundColor: '#e56521', borderColor: '#ec4d13' }}
              disabled={loading}
            >
              Check Coverage
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoverageCheckModal;
